export default __webpack_public_path__ + "static/media/filter-empty.e845d859.svg";